import { Injectable } from '@angular/core';

import { Constants } from '../shared/constants';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class JoineeService {

  constructor(private apiService: ApiService) { }


  async saveNewJoineeDetails(payload: any) {
    return await this.apiService.post(Constants.API_URL_SAVE_NEW_JOINEE_DETAILS, payload)
      .toPromise()
      .catch(this.apiService.handleError('saveNewJoineeDetails', []));
  }

  async getDocumentDeteails(data: any) {
    return await this.apiService.get(Constants.API_URL_GET_DOCUMENT_DETAILS+data)
      .toPromise()
      .catch(this.apiService.handleError('getDocumentDetatils', []));
  }

  async getNewJoineeList(){
    return await this.apiService.get(Constants.API_URL_GET_NEW_JOINEE_DETAILS)
    .toPromise()
    .catch(this.apiService.handleError('getNewJoineeList',[]));
  }

  async getJoineeListByName(data:string){
    return await this.apiService.get(Constants.API_URL_GET_NEW_JOINEE_DETAILS_BY_NAME+data)
    .toPromise()
    .catch(this.apiService.handleError('getNewJoineeList',[]));
  }

  async getJoineeListByNameAndDate(data:string,startDate:string, endDate:string){
    return await this.apiService.get(Constants.API_URL_GET_NEW_JOINEE_DETAILS_BY_NAME_DATE+data+'/'+startDate+'/'+endDate)
    .toPromise()
    .catch(this.apiService.handleError('getNewJoineeList',[]));
  }


  
  async getJoineeListBymobile(data:string){
    return await this.apiService.get(Constants.API_URL_GET_NEW_JOINEE_DETAILS_BY_MOBILE+data)
    .toPromise()
    .catch(this.apiService.handleError('getNewJoineeList',[]));
  }

  async getJoineeListBymobileAndDate(data:string,startDate:string, endDate:string){
    return await this.apiService.get(Constants.API_URL_GET_NEW_JOINEE_DETAILS_BY_MOBILE_DATE+data+'/'+startDate+'/'+endDate)
    .toPromise()
    .catch(this.apiService.handleError('getNewJoineeList',[]));
  }

  async getJoineeListByFunction(data:string){
    return await this.apiService.get(Constants.API_URL_GET_NEW_JOINEE_DETAILS_BY_FUNCTION+data)
    .toPromise()
    .catch(this.apiService.handleError('getNewJoineeList',[]));
  }

  async getJoineeListByFunctionAndDate(data:string,startDate:string, endDate:string){
    return await this.apiService.get(Constants.API_URL_GET_NEW_JOINEE_DETAILS_BY_FUNCTION_DATE+data+'/'+startDate+'/'+endDate)
    .toPromise()
    .catch(this.apiService.handleError('getNewJoineeList',[]));
  }

  async getJoineeListByNameAndFunction(data:string){
    return await this.apiService.get(Constants.API_URL_GET_NEW_JOINEE_DETAILS_BY_FUNCTION+data)
    .toPromise()
    .catch(this.apiService.handleError('getNewJoineeList',[]));
  }

  async getJoineeListByDate(startDate:string,endDate:string){
    return await this.apiService.get(Constants.API_URL_GET_NEW_JOINEE_DETAILS_BY_DATE+startDate+"/"+endDate)
    .toPromise()
    .catch(this.apiService.handleError('getNewJoineeList',[]));
  }

  async getAgeMaster(){
    return await this.apiService.get(Constants.API_URL_GET_AGE_MASTER)
    .toPromise()
    .catch(this.apiService.handleError('getAgeMasterData',[]));
  }

  async getInsuranceQualificationMaster(){
    return await this.apiService.get(Constants.API_URL_GET_INSURANCE_QUALIFICATION_MASTER)
    .toPromise()
    .catch(this.apiService.handleError('getInsuranceQualificatonData',[]));
  }

  async getHighestEducationMaster(){
    return await this.apiService.get(Constants.API_URL_GET_HIGHEST_EDUCATION_MASTER)
    .toPromise()
    .catch(this.apiService.handleError('getHighestEducationMasterData',[]));
  }

  async getFunctionMaster(){
    return await this.apiService.get(Constants.API_URL_GET_FUNCTION_MASTER)
    .toPromise()
    .catch(this.apiService.handleError('getFunctionMasterData',[]));
  }

  async getExperienceMaster(){
    return await this.apiService.get(Constants.API_URL_GET_EXPERIENCE_MASTER)
    .toPromise()
    .catch(this.apiService.handleError('getExperienceMasterData',[]));
  }

  async getNoticePeriodMaster(){
    return await this.apiService.get(Constants.API_URL_GET_NOTICE_PERIOD_MASTER)
    .toPromise()
    .catch(this.apiService.handleError('getNoticePeriodMasterData',[]));
  }

  async getCTCMaster(){
    return await this.apiService.get(Constants.API_URL_GET_CURRENT_CTC_MASTER)
    .toPromise()
    .catch(this.apiService.handleError('getCtcMasterData',[]));
  }

  async getStateMaster(){
    return await this.apiService.get(Constants.API_URL_GET_STATE_MASTER)
    .toPromise()
    .catch(this.apiService.handleError('getStateMasterData',[]));
  }

  async getLocationMaster(){
    return await this.apiService.get(Constants.API_URL_GET_LOCATION_MASTER)
    .toPromise()
    .catch(this.apiService.handleError('getLocationMaster',[]));
  }

  async saveCandidateDocuments(payload: any){
    return await this.apiService.post(Constants.API_URL_SAVE_CANDIDATE_DETAILS, payload)
      .toPromise()
      .catch(this.apiService.handleError('saveNewJoineeDetails', []));
  }

  async getDocument(documentumID) {
    return this.apiService.get(Constants.API_URL_GET_DOCUMENT + documentumID)
      .toPromise()
      .catch(this.apiService.handleError('getDocument', []));
  }

  

  async saveCandidateDetails(payload: any) {
    return await this.apiService.post(Constants.API_URL_SAVE_CANDIDATE_DETAILS, payload)
    .toPromise()
      .catch(this.apiService.handleError('saveCandidateDetails', []));
  }

  async checkAlreadyExist(payload: any){
    return await this.apiService.post(Constants.API_URL_CHECK_CANDIDATE_EXISTS, payload)
      .toPromise()
      .catch(this.apiService.handleError('checkCandidateExists', []));
  }

  async getRequests(payload: any) {
    return await this.apiService.post(Constants.API_URL_GET_REQUESTS, payload)
      .toPromise()
      .catch(this.apiService.handleError('getRequests', []));
  }

  // async getJoineeDetails(){
  //   return await this.apiService.get("http://localhost:8080/hiring/")
  // }
}
